import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { TextInputField } from 'common/components/form_fields';
import isEmail from 'sane-email-validation';
import moment from 'moment';

const PaypalForm = ({error, handleSubmit, submitting, submitFailed, onCancel, account}) => (
  <form onSubmit={handleSubmit}>
    { account && account.updated &&
    <p className="account-last-updated">
      This account was last updated on { moment(account.updated).format('MMM DD, h:mm a') }.
    </p> }
    <Field name="email" label="Email" component={TextInputField} />
    <div className="modal-actions">
      <AnimatedButton processing={submitting} label="Done" onClick={handleSubmit}
        processingLabel="Wait..." errorMsg={error || submitFailed}
        successMsg="Done"/>
      <button className="btn btn-text btn-block" onClick={onCancel}>
        Cancel
      </button>
    </div>
  </form>
)

const validate = values => {
  if (!values['email'] || !isEmail(values['email']))
    return {email: 'Please provide a valid email'}
  return {}
}

export default reduxForm({
  form: "PaypalForm",
  validate,
})(PaypalForm);



// WEBPACK FOOTER //
// ./account/components/payout/paypal_form.jsx